import React from "react";
import {useParams} from "react-router-dom";
import {PageHeader} from "../../../components/PageHeader";
import {saveBulletinboard} from "../../../api/bulletinboard/BulletinboardService";
import ContentRegisterForm from "../shared/ContentRegisterForm";

function BulletinboardCreate() {
    const {type: typeParam} = useParams();
    const gubun = typeParam === "request" ? "request" : "main";

    const pageHeader = gubun === "request"
        ? <PageHeader header="요청자료실" indicator="서비스요청 > 요청자료실 > 등록" />
        : <PageHeader header="자료실" indicator="환경설정 > 알람관리 > 자료실 > 등록" />;

    return (
        <ContentRegisterForm
            gubun={gubun}
            pageHeader={pageHeader}
            cancelPath={`/settings/bulletinboardlist/${gubun}`}
            onSubmit={saveBulletinboard}
            successPath={(id) => `/settings/bulletinboard/${id}`}
        />
    );
}

export {BulletinboardCreate};
